// The settings dialog, and the language switch of the screens before signing in
const en = {
  title: 'Settings',
  language: 'Language',
  languageHint: (email: string) =>
    `Saved on your account (${email}), so the backoffice opens in this language on every device.`,
  languageNotSaved: "The language couldn't be saved on your account. Try again later.",
};

const fr: typeof en = {
  title: 'Paramètres',
  language: 'Langue',
  languageHint: (email: string) =>
    `Enregistrée sur votre compte (${email}), pour que le back-office s'ouvre dans cette langue sur tous vos appareils.`,
  languageNotSaved: "La langue n'a pas pu être enregistrée sur votre compte. Réessayez plus tard.",
};

const messages = { en, fr };
export default messages;
